import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlogArchive"] */ "/app/src/components/blog/BlogArchive.tsx");
